import { __read, __spreadArray } from "tslib";
export function debugLog() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (process && process.env && process.env.DEBUG && !process.env.GQL_tools_NODEBUG) {
        // tslint:disable-next-line: no-console
        console.log.apply(console, __spreadArray([], __read(args)));
    }
}
//# sourceMappingURL=debug-log.js.map